export default __webpack_public_path__ + "static/media/arrow-right.4b4bbbf7.svg";